import styled from "styled-components";
import { Link } from "react-router-dom";

export const LastOptionsContainer = styled.div`
  opacity: 1;
  z-index: 2;
  padding: var(--sp-20);
`;
export const Card = styled.div`
  background-color: ${(props) => props.theme.colors.background + "cc"};
  color: ${(props) => props.theme.colors.text};
  border: 1px solid ${(props) => props.theme.colors.text};
  padding: var(--sp-20);
  border-radius: 8px;
`;
export const Icon = styled.div`
  font-family: "Material Icons";
  text-align: center;
  font-size: var(--fs-5xl);
  color: ${(props) => props.theme.colors.selection};
  text-shadow: -0.5px -0.5px 0 #000, 0.5px -0.5px 0 #000, -0.5px 0.5px 0 #000,
    1px 1px 0 #000;
`;

export const Title = styled.h2`
  text-align: center;
  margin-bottom: var(--sp-10);
  color: ${(props) => props.theme.colors.selection};
  text-shadow: -0.2px -0.2px 0 #000, 0.2px -0.2px 0 #000, -0.2px 0.2px 0 #000,
    0.5px 0.5px 0 #000;
`;

export const LastPagesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageItem = styled(Link)`
  padding: var(--sp-8);
  margin: var(--sp-4) 0;
  /* Superfície do tema: era branco fixo, e o texto do tema (claro no escuro)
     ficava por cima dele. Medido: 1,17:1. */
  background-color: ${(props) => props.theme.colors.primary};
  border: 2px solid rgba(224, 224, 224, 0.5);
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  flex-direction: row;
  display: flex;
  justify-content: center;
  text-decoration: none;
  color: ${(props) => props.theme.colors.text};

  &:hover {
    border-color: ${(props) => props.theme.colors.selection};
    color: ${(props) => props.theme.colors.selection};
  }
`;

export const PageTitle = styled.div`
  font-size: 110%;
  font-weight: bold;
`;

export const PageIcon = styled.div`
  font-family: "Material Icons";
  font-size: 150%;
  margin-right: var(--sp-10);
`;
